import { render, staticRenderFns } from "./subproperty-dashboard-finantial.vue?vue&type=template&id=3bb22a94&scoped=true&"
import script from "./subproperty-dashboard-finantial.vue?vue&type=script&lang=js&"
export * from "./subproperty-dashboard-finantial.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-dashboard-finantial.vue?vue&type=style&index=0&id=3bb22a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb22a94",
  null
  
)

export default component.exports